import { Match } from './match.model';

export class WinnerOf {
  matchId: number;

  constructor(match: Match) {
    this.matchId = match.id;
  }
}
